import { Route, Routes, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import Loader from '../components/Loader';
import { useAuth } from '../context/AuthContext';

const Login = lazy(() => import('../pages/Login'));
const RegisterPatient = lazy(() => import('../pages/RegisterPatient'));
const ForgetPassword = lazy(() => import('../pages/ForgetPassword'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const PatientManagement = lazy(() => import('../pages/PatientManagement'));
const PatientHistory = lazy(() => import('../pages/PatientHistory'));
const FollowUps = lazy(() => import('../pages/FollowUps'));
const Issues = lazy(() => import('../pages/Issues'));
const PatientDetail = lazy(() => import('../pages/PatientDetail'));
const PrescriptionPrint = lazy(() => import('../pages/PrescriptionPrint'));
const Admin = lazy(() => import('../pages/Admin'));
const VisitRequests = lazy(() => import('../pages/VisitRequests'));
const VisitAvailability = lazy(() => import('../pages/VisitAvailability'));
const PatientVisits = lazy(() => import('../pages/PatientVisits'));
const PatientMyHistory = lazy(() => import('../pages/PatientMyHistory'));
const VerifyContact = lazy(() => import('../pages/VerifyContact'));
const Notices = lazy(() => import('../pages/Notices'));

const AppRoutes = () => {
    const { isAuthenticated, activeUser } = useAuth();
    const isPatient = activeUser?.role === 'patient';
    const needsVerify = isPatient && activeUser?.isContactVerified === false;

    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register-patient" element={<RegisterPatient />} />
                <Route path="/forget-password" element={<ForgetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />

                {isAuthenticated ? (
                    needsVerify ? (
                        <>
                            <Route path="/verify" element={<VerifyContact />} />
                            <Route path="*" element={<Navigate to="/verify" />} />
                        </>
                    ) : isPatient ? (
                        <>
                            <Route path="/my-visits" element={<PatientVisits />} />
                            <Route path="/my-history" element={<PatientMyHistory />} />
                            <Route path="/notices" element={<Notices />} />
                            <Route
                                path="/prescriptions/:prescriptionID/print"
                                element={<PrescriptionPrint />}
                            />
                            <Route path="*" element={<Navigate to="/my-visits" />} />
                        </>
                    ) : (
                    <>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route
                            path="/patients"
                            element={<PatientManagement />}
                        />
                        <Route
                            path="/patients/:patientID"
                            element={<PatientDetail />}
                        />
                        <Route
                            path="/visit-history"
                            element={<PatientHistory />}
                        />
                        <Route
                            path="/follow-ups"
                            element={<FollowUps />}
                        />
                        <Route
                            path="/issues"
                            element={<Issues />}
                        />
                        <Route
                            path="/visit-requests"
                            element={<VisitRequests />}
                        />
                        <Route
                            path="/availability"
                            element={<VisitAvailability />}
                        />
                        <Route
                            path="/notices"
                            element={<Notices />}
                        />
                        <Route
                            path="/prescriptions/:prescriptionID/print"
                            element={<PrescriptionPrint />}
                        />
                        {activeUser?.role === 'admin' && (
                            <Route path="/admin" element={<Admin />} />
                        )}
                        <Route
                            path="*"
                            element={<Navigate to="/dashboard" />}
                        />
                    </>
                    )
                ) : (
                    <Route path="*" element={<Navigate to="/login" />} />
                )}
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;
